import { render, staticRenderFns } from "./InfoEmpikGo.vue?vue&type=template&id=629f8dc0"
import script from "./InfoEmpikGo.vue?vue&type=script&lang=js"
export * from "./InfoEmpikGo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports